/**
 * Insert a tracking pixel in the given document
 */
import Env from './env'
import Logger from './logger'

let isInserted = false

function insert({ advertiserId, document, firstScriptElement, productId }) {
  if (isInserted) {
    Logger.warn('ignore redundant insert of dt pixel')
    return
  }

  if (!advertiserId || String(advertiserId).trim().length === 0) {
    Logger.warn('cannot insert dt pixel due to missing advertiserId')
    return
  }

  if (!document) {
    Logger.warn('cannot insert dt pixel due to missing document')
    return
  }

  isInserted = true

  const advertiserIdStr = String(advertiserId)
  const decodedAdvertiserId = advertiserIdStr.substring(0, advertiserIdStr.length - 1)

  if (!firstScriptElement) {
    firstScriptElement = document.getElementsByTagName('script')[0]
  }

  const trackingScriptElement = document.createElement('script')
  trackingScriptElement.async = 1
  trackingScriptElement.src =
    Env.DATA_TRACKING_PXL_URL() +
    encodeURIComponent(decodedAdvertiserId) +
    _withTrackingProductId(productId)

  firstScriptElement.parentNode.insertBefore(trackingScriptElement, firstScriptElement)
}

/*
  _withTrackingProductId - Appends the productid? parameter for targeting
  productId: Comes from the scraper
  productIdPassedIn: Comes from data-productid in the script tag setup by the advertiser in the webpage
*/
function _withTrackingProductId(productId) {
  let productIdPassedIn = window.adacado.productIdPassedIn
  if (productId) {
    return `?productid=${encodeURIComponent(productId)}`
  }
  if (productIdPassedIn) {
    return `?productid=${encodeURIComponent(productIdPassedIn)}`
  }
  return ``
}

export default {
  insert,
}
